"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReactDOM = require("react-dom");
var index_1 = require("../src/ontodia/index");
var common_1 = require("./common");
var WIKIDATA_PREFIX = 'http://www.wikidata.org/prop/direct/';
var workspace;
function getElementLabel(id) {
    var model = workspace.getModel();
    var view = workspace.getDiagram();
    var element = model.getElement(id);
    return element ? view.formatLabel(element.data.label.values, element.iri) : '';
}
function wikidataSuggestProperties(params) {
    var idMap = {};
    var properties = params.properties.map(function (id) {
        var resultID;
        if (id.startsWith(WIKIDATA_PREFIX)) {
            resultID = id.substr(WIKIDATA_PREFIX.length, id.length);
        }
        else {
            resultID = id;
        }
        idMap[resultID] = id;
        return resultID;
    });
    var term = params.token.toLowerCase() || getElementLabel(params.elementId);
    var requestBody = {
        threshold: 0.1,
        term: term,
        instance_properties: properties,
    };
    return fetch('/wikidata-prop-suggest', {
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'same-origin',
        mode: 'cors',
        cache: 'default',
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        }
        else {
            var error = new Error(response.statusText);
            error.response = response;
            throw error;
        }
    }).then(function (json) {
        var dictionary = {};
        for (var _i = 0, _a = json.data; _i < _a.length; _i++) {
            var scoredItem = _a[_i];
            var propertyIri = idMap[scoredItem.id];
            var item = dictionary[propertyIri];
            if (item && item.score > scoredItem.value) {
                continue;
            }
            dictionary[propertyIri] = { propertyIri: propertyIri, score: scoredItem.value };
        }
        Object.keys(idMap).forEach(function (key) {
            var propertyIri = idMap[key];
            if (dictionary[propertyIri]) {
                return;
            }
            dictionary[propertyIri] = { propertyIri: propertyIri, score: 0 };
        });
        return dictionary;
    });
}
function onWorkspaceMounted(wspace) {
    if (!wspace) {
        return;
    }
    workspace = wspace;
    var diagram = common_1.tryLoadLayoutFromLocalStorage();
    var dataProvider = new index_1.SparqlDataProvider({
        endpointUrl: '/wikidata',
        imagePropertyUris: [
            'http://www.wikidata.org/prop/direct/P18',
            'http://www.wikidata.org/prop/direct/P154',
        ],
        queryMethod: index_1.SparqlQueryMethod.POST,
    }, index_1.WikidataSettings);
    workspace.getModel().importLayout({ diagram: diagram, dataProvider: dataProvider, validateLinks: true });
}
var props = {
    ref: onWorkspaceMounted,
    onSaveDiagram: function (self) {
        var diagram = self.getModel().exportLayout();
        window.location.hash = common_1.saveLayoutToLocalStorage(diagram);
        window.location.reload();
    },
    viewOptions: {
        suggestProperties: wikidataSuggestProperties,
        onIriClick: function (_a) {
            var iri = _a.iri;
            return window.open(iri);
        },
    },
};
common_1.onPageLoad(function (container) { return ReactDOM.render(react_1.createElement(index_1.Workspace, props), container); });
